import { Stack } from '@mui/material'
import React from 'react'


const Scrim = ({ children }) => {
  return (
    <Stack
      sx={{
        maxWidth: '1440px',
        width: '100%',
        minHeight: '100vh',
        height: '100%',
        alignItems: 'center',
        background: '#2F3033',
      }}
    >
      {children}
    </Stack>
  );
};

export default Scrim
